import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const SectionContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#fdfcfa',
  padding: '20px 0 60px 0',
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    right: 0,
    width: '40%',
    height: '100%',
    background: 'linear-gradient(135deg, rgba(180, 160, 130, 0.05) 0%, rgba(166, 144, 128, 0.1) 100%)',
    borderRadius: '0 0 0 100px',
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    right: 0,
    width: '100%',
    height: '100%',
    backgroundImage: `url("data:image/svg+xml,%3Csvg width='400' height='600' viewBox='0 0 400 600' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3Cstyle%3E.stem%7Bfill:none;stroke:%23c2b8a8;stroke-width:2;opacity:0.4;%7D.wheat-head%7Bfill:%23c2b8a8;opacity:0.4;%7D.awn%7Bfill:none;stroke:%23c2b8a8;stroke-width:0.5;opacity:0.25;%7D%3C/style%3E%3C/defs%3E%3Cg%3E%3C!-- Tall wheat stalk 1 (leaning left) --%3E%3Cpath class='stem' d='M340 580 Q330 450 305 320 Q280 190 250 80 Q230 30 210 10'/%3E%3C!-- Wheat head 1 (tall, oval shape) --%3E%3Cpath class='wheat-head' d='M210 10 Q225 8 235 25 Q240 45 235 65 Q230 85 220 95 Q210 100 200 95 Q190 85 185 65 Q180 45 185 25 Q190 8 210 10 Z'/%3E%3C!-- Awns radiating from head 1 --%3E%3Cpath class='awn' d='M210 15 L195 5'/%3E%3Cpath class='awn' d='M220 18 L208 8'/%3E%3Cpath class='awn' d='M230 25 L220 15'/%3E%3Cpath class='awn' d='M235 35 L228 25'/%3E%3Cpath class='awn' d='M235 45 L228 35'/%3E%3Cpath class='awn' d='M230 55 L223 45'/%3E%3Cpath class='awn' d='M220 65 L213 55'/%3E%3Cpath class='awn' d='M195 20 L185 10'/%3E%3Cpath class='awn' d='M190 35 L180 25'/%3E%3Cpath class='awn' d='M185 50 L175 40'/%3E%3C!-- Medium wheat stalk 2 --%3E%3Cpath class='stem' d='M370 580 Q360 480 335 380 Q310 280 285 180 Q270 130 255 90'/%3E%3C!-- Wheat head 2 (medium size) --%3E%3Cpath class='wheat-head' d='M255 90 Q265 88 270 100 Q273 115 270 130 Q265 145 255 150 Q245 145 240 130 Q237 115 240 100 Q245 88 255 90 Z'/%3E%3C!-- Awns from head 2 --%3E%3Cpath class='awn' d='M255 95 L245 85'/%3E%3Cpath class='awn' d='M262 98 L252 88'/%3E%3Cpath class='awn' d='M268 105 L258 95'/%3E%3Cpath class='awn' d='M270 115 L260 105'/%3E%3Cpath class='awn' d='M268 125 L258 115'/%3E%3Cpath class='awn' d='M260 135 L250 125'/%3E%3Cpath class='awn' d='M248 100 L238 90'/%3E%3Cpath class='awn' d='M242 115 L232 105'/%3E%3C!-- Short wheat stalk 3 --%3E%3Cpath class='stem' d='M300 580 Q290 520 265 460 Q240 400 215 340 Q200 300 185 260'/%3E%3C!-- Wheat head 3 (smaller) --%3E%3Cpath class='wheat-head' d='M185 260 Q192 258 196 268 Q198 278 196 288 Q192 298 185 300 Q178 298 174 288 Q172 278 174 268 Q178 258 185 260 Z'/%3E%3C!-- Awns from head 3 --%3E%3Cpath class='awn' d='M185 265 L178 255'/%3E%3Cpath class='awn' d='M190 267 L183 257'/%3E%3Cpath class='awn' d='M194 272 L187 262'/%3E%3Cpath class='awn' d='M196 280 L189 270'/%3E%3Cpath class='awn' d='M194 288 L187 278'/%3E%3Cpath class='awn' d='M190 293 L183 283'/%3E%3Cpath class='awn' d='M180 270 L173 260'/%3E%3Cpath class='awn' d='M176 285 L169 275'/%3E%3C!-- Very tall wheat stalk 4 --%3E%3Cpath class='stem' d='M320 580 Q310 420 285 260 Q260 100 235 40 Q220 15 205 5'/%3E%3C!-- Wheat head 4 (long and narrow) --%3E%3Cpath class='wheat-head' d='M205 5 Q215 3 220 15 Q223 30 220 45 Q217 60 210 70 Q205 75 200 70 Q195 60 192 45 Q189 30 192 15 Q197 3 205 5 Z'/%3E%3C!-- Awns from head 4 --%3E%3Cpath class='awn' d='M205 10 L195 0'/%3E%3Cpath class='awn' d='M212 12 L202 2'/%3E%3Cpath class='awn' d='M218 18 L208 8'/%3E%3Cpath class='awn' d='M220 25 L210 15'/%3E%3Cpath class='awn' d='M220 35 L210 25'/%3E%3Cpath class='awn' d='M218 45 L208 35'/%3E%3Cpath class='awn' d='M210 55 L200 45'/%3E%3Cpath class='awn' d='M198 18 L188 8'/%3E%3Cpath class='awn' d='M194 30 L184 20'/%3E%3Cpath class='awn' d='M192 42 L182 32'/%3E%3C!-- Medium-short stalk 5 --%3E%3Cpath class='stem' d='M280 580 Q270 500 245 420 Q220 340 195 260 Q180 220 165 180'/%3E%3C!-- Wheat head 5 (compact) --%3E%3Cpath class='wheat-head' d='M165 180 Q172 178 176 188 Q178 198 176 208 Q172 218 165 220 Q158 218 154 208 Q152 198 154 188 Q158 178 165 180 Z'/%3E%3C!-- Awns from head 5 --%3E%3Cpath class='awn' d='M165 185 L158 175'/%3E%3Cpath class='awn' d='M170 187 L163 177'/%3E%3Cpath class='awn' d='M174 192 L167 182'/%3E%3Cpath class='awn' d='M176 200 L169 190'/%3E%3Cpath class='awn' d='M174 208 L167 198'/%3E%3Cpath class='awn' d='M170 213 L163 203'/%3E%3Cpath class='awn' d='M160 192 L153 182'/%3E%3Cpath class='awn' d='M156 205 L149 195'/%3E%3C/g%3E%3C/svg%3E")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right center',
    backgroundSize: '250px auto',
    zIndex: 0,
    pointerEvents: 'none'
  }
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  color: '#B4A082',
  fontWeight: 400,
  letterSpacing: '0.2em',
  textTransform: 'uppercase',
  fontSize: '0.9rem',
  marginBottom: '24px',
  // Ultra-wide screens
  '@media (min-width: 1920px)': {
    fontSize: '1rem',
    marginBottom: '28px'
  },
  // Large screens
  '@media (min-width: 1536px) and (max-width: 1920px)': {
    fontSize: '0.95rem',
    marginBottom: '26px'
  },
  [theme.breakpoints.down('xl')]: {
    fontSize: '0.9rem'
  },
  [theme.breakpoints.down('lg')]: {
    fontSize: '0.85rem',
    marginBottom: '20px'
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '0.8rem',
    marginBottom: '18px'
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.75rem',
    marginBottom: '16px'
  },
  '@media (max-width: 480px)': {
    fontSize: '0.7rem',
    marginBottom: '14px'
  }
}));

const MainHeading = styled(Typography)(({ theme }) => ({
  color: '#000000',
  fontWeight: 300,
  lineHeight: 1.2,
  marginBottom: '40px',
  fontSize: '3rem',
  letterSpacing: '1px',
  fontFamily: 'Lora, serif',
  // Ultra-wide screens
  '@media (min-width: 1920px)': {
    fontSize: '4rem',
    marginBottom: '48px'
  },
  // Large screens
  '@media (min-width: 1536px) and (max-width: 1920px)': {
    fontSize: '3.8rem',
    marginBottom: '44px'
  },
  [theme.breakpoints.down('xl')]: {
    fontSize: '3.5rem'
  },
  [theme.breakpoints.down('lg')]: {
    fontSize: '3rem',
    marginBottom: '36px'
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '2.5rem',
    marginBottom: '32px'
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '2rem',
    marginBottom: '24px',
    lineHeight: 1.3
  },
  '@media (max-width: 480px)': {
    fontSize: '1.8rem',
    marginBottom: '20px',
    lineHeight: 1.4
  }
}));

const ContentText = styled(Typography)(({ theme }) => ({
  color: '#000000',
  lineHeight: 1.8,
  fontSize: '1.1rem',
  marginBottom: '32px',
  maxWidth: '600px',
  // Ultra-wide screens
  '@media (min-width: 1920px)': {
    fontSize: '1.3rem',
    marginBottom: '36px',
    maxWidth: '700px'
  },
  // Large screens
  '@media (min-width: 1536px) and (max-width: 1920px)': {
    fontSize: '1.2rem',
    marginBottom: '34px',
    maxWidth: '650px'
  },
  [theme.breakpoints.down('xl')]: {
    fontSize: '1.1rem'
  },
  [theme.breakpoints.down('lg')]: {
    fontSize: '1.05rem',
    marginBottom: '28px',
    maxWidth: '550px'
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '1rem',
    marginBottom: '24px',
    maxWidth: '500px'
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.95rem',
    marginBottom: '20px',
    maxWidth: '100%',
    lineHeight: 1.7
  },
  '@media (max-width: 480px)': {
    fontSize: '0.9rem',
    marginBottom: '16px',
    lineHeight: 1.6
  }
}));

const HighlightText = styled(Typography)(({ theme }) => ({
  color: '#B4A082',
  fontWeight: 500,
  fontSize: '1.3rem',
  marginBottom: '24px',
  letterSpacing: '0.5px'
}));

const AboutSection: React.FC = () => {
  return (
    <SectionContainer>
      <Container maxWidth="lg">
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'flex-start', 
          minHeight: 'auto',
          paddingTop: '20px',
          flexDirection: { xs: 'column', md: 'row' },
          gap: { xs: 6, md: 8 }
        }}>
          {/* Left Content */}
          <Box sx={{ 
            flex: 1, 
            position: 'relative', 
            zIndex: 2,
            maxWidth: { md: '50%' }
          }}>
            <SectionTitle>
            Sobre EkkoFood
            </SectionTitle>
            
            <MainHeading>
            Nuestra esencia: <br />
             salud y sostenibilidad

            </MainHeading>
            
            <ContentText sx={{ mb: 3 }}>
            En Ekkofood cultivamos mucho más que alimentos: cultivamos salud, sostenibilidad y comunidad. Desde nuestra finca ecológica en Valencia, promovemos la agricultura regenerativa con el objetivo de hacer que los productos orgánicos sean accesibles para todos.
            </ContentText>
            
            <ContentText sx={{ mb: 4 }}>
            Nuestro equipo combina décadas de experiencia en medicina, nutrición y agricultura con la pasión de una familia que cree en un futuro más sano y justo. 

            </ContentText>
            <ContentText sx={{ mb: 5 }}>
            Aquí encontrarás cursos, talleres y experiencias que inspiran a agricultores, empresas y personas a transformar su manera de producir y consumir alimentos.
 

            </ContentText>
            <Button
              variant="contained"
              href="/quienes-somos"
              sx={{
                backgroundColor: '#455b40',
                color: 'white',
                px: { xs: 3, sm: 4, md: 5 },
                py: { xs: 1.5, sm: 1.8, md: 2 },
                fontSize: {
                  xs: '0.85rem',
                  sm: '0.9rem',
                  md: '1rem',
                  lg: '1.05rem',
                  xl: '1.1rem'
                },
                // Ultra-wide screens
                '@media (min-width: 1920px)': {
                  fontSize: '1.2rem',
                  px: 6,
                  py: 2.5
                },
                fontWeight: 500,
                borderRadius: '50px',
                textTransform: 'none',
                letterSpacing: '0.5px',
                boxShadow: '0 8px 25px rgba(166, 144, 128, 0.3)',
                transition: 'all 0.3s ease',
                minHeight: { xs: '44px', sm: '48px', md: '52px' },
                '&:hover': {
                  backgroundColor: '#6c8c68',
                  transform: 'translateY(-3px)',
                  boxShadow: '0 12px 35px rgba(166, 144, 128, 0.4)',
                },
              }}
            >
              Quiénes Somos
            </Button>
          </Box>

          {/* Right Visual Element */}
          <Box sx={{ 
            flex: 1,
            maxWidth: { md: '50%' },
            width: '100%',
            marginTop: { xs: 0, md: '120px' }
          }}>
            <Box
              sx={{
                position: 'relative',
                height: { 
                  xs: '280px', 
                  sm: '320px',
                  md: '450px',
                  lg: '500px',
                  xl: '550px'
                },
                // Ultra-wide screens
                '@media (min-width: 1920px)': {
                  height: '600px'
                },
                // Large screens
                '@media (min-width: 1536px) and (max-width: 1920px)': {
                  height: '575px'
                },
                // Extra small mobile
                '@media (max-width: 480px)': {
                  height: '250px'
                },
                borderRadius: '20px',
                overflow: 'hidden',
                boxShadow: '0 20px 60px rgba(0,0,0,0.1)'
              }}
            >
              <Box
                component="img"
                src="/Nuestra escencia - Ekkofood.jpg"
                alt="Ekkofood organic farm landscape"
                sx={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  filter: 'brightness(1.1) contrast(1.1)'
                }}
              />
              
              {/* Overlay with subtle gradient */}
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'linear-gradient(135deg, rgba(166, 144, 128, 0.1) 0%, transparent 50%)',
                }}
              />
              
            </Box>
          </Box>
        </Box>
      </Container>
    </SectionContainer>
  );
};

export default AboutSection;